module.exports = __webpack_public_path__ + "img/hx.5cae74eb.png";